import { makeStyles, css } from '@conexasaude/hero'

const useStyles = makeStyles({
  userProfileCard({ colors }) {
    return css`
      margin-bottom: 20px;
      width: 100%;
      height: auto;
      background: ${colors.primary[100]};
      border: 1px solid ${colors.primary[500]};
      box-sizing: border-box;
      box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
      border-radius: 8px;
      padding: 23px;

      .itens_card {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 100%;
      }
      .avatar_card {
        display: none;
        width: 48px;
        height: 48px;
        align-items: center;
        justify-content: center;
      }
      .text_card {
        display: flex;
        flex-direction: column;
        margin-left: 24px;
        align-items: flex-start;
        flex-grow: 1;
        justify-content: center;
      }
      .name_card {
        color: ${colors.common.black};
        font-size: 18px;
        display: inline-block;
      }
      .clinic_card {
        color: ${colors.neutral[500]};
      }
      .speciality_card {
        color: ${colors.primary[500]};
        p {
          font-size: 14px;
          text-decoration: underline;
          cursor: pointer;
        }
      }
      .icon_card {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        @media (max-width: 639px) {
          margin-left: 7px;
        }
      }
      @media (min-width: 640px) {
        display: flex;
        align-items: center;
        width: 512px;
        .avatar_card {
          display: flex;
        }
      }
    `
  },
})

export default useStyles
